module.exports = __webpack_public_path__ + "media/images/landing_page/2023/album/album_large_en-b72cf3f4a21a3418fbebe3352d9f606d.webp";